"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterOldRecurrencies = exports.parseRecurringRule = void 0;
const __1 = require("..");
const channels_1 = require("../types/channels");
const date_1 = require("./date");
/**
 *  Parse recurring rule into array of objects containing startDate and endDate.
 * - Note: must be called from client to ensure DateTime is correct
 * @param start
 * @param end
 * @param rule
 * @returns
 */
const parseRecurringRule = (start, end, rule) => {
    const { interval, freq, endDate: ruleEndDate } = rule;
    const startDate = typeof start === 'string' ? __1.getScheduleDateTimeFromDate(new Date(start)) : start;
    const endDate = typeof end === 'string' ? __1.getScheduleDateTimeFromDate(new Date(end)) : end;
    // if no rule end date exists, use current date + 12 months
    const recurrenceEndDate = ruleEndDate ? new Date(ruleEndDate) : date_1.addMonths(date_1.getCurrentDate(), 12);
    const dateRanges = [
        {
            startDate,
            endDate
        }
    ];
    let currentStartDate = __1.getDateFromScheduleDateTime(startDate);
    let currentEndDate = __1.getDateFromScheduleDateTime(endDate);
    while (currentEndDate.getTime() < recurrenceEndDate.getTime()) {
        currentStartDate = addFrequency(freq, interval, currentStartDate, recurrenceEndDate);
        currentEndDate = addFrequency(freq, interval, currentEndDate, recurrenceEndDate);
        if (currentEndDate.getTime() <= recurrenceEndDate.getTime()) {
            dateRanges.push({
                startDate: __1.getScheduleDateTimeFromDate(currentStartDate),
                endDate: __1.getScheduleDateTimeFromDate(currentEndDate)
            });
        }
    }
    return dateRanges;
};
exports.parseRecurringRule = parseRecurringRule;
/**
 * Increment date by given frequency and interval. If frequency for some reason not supported, end loop by
 * returning recurrenceEndDate
 * @param recurrenceEndDate end date to stop loop
 */
const addFrequency = (freq, interval, currentDate, recurrenceEndDate) => {
    if (freq === channels_1.RecurringFrequency.WEEKLY) {
        return date_1.addDays(currentDate, 7 * interval);
    }
    else if (freq === channels_1.RecurringFrequency.MONTHLY) {
        return date_1.addMonths(currentDate, 1 * interval);
    }
    return recurrenceEndDate;
};
/**
 * Filter out recurrencies that have already ended, return only current and future date ranges
 * @param dateRanges
 */
const filterOldRecurrencies = (dateRanges) => {
    const dateNow = new Date();
    return dateRanges.filter(({ endDate }) => __1.getDateFromScheduleDateTime(endDate).getTime() >= dateNow.getTime());
};
exports.filterOldRecurrencies = filterOldRecurrencies;
//# sourceMappingURL=recurrance.js.map